import { Button, Card, Checkbox, Space, Tag, Typography } from "antd";
import { Image as ImageIcon } from "lucide-react";
import type { SupplierProductListItem } from "../types";

const { Text } = Typography;

const SELECTED_BORDER = "#195178";

export type SupplierProductListCardProps = {
  product: SupplierProductListItem;
  selected: boolean;
  loading?: boolean;
  onToggle: (product: SupplierProductListItem) => void;
  onOpen: (product: SupplierProductListItem) => void;
};

export const SupplierProductListCard: React.FC<SupplierProductListCardProps> = ({
  product,
  selected,
  loading,
  onToggle,
  onOpen,
}) => {
  return (
    <Card
      hoverable
      loading={loading}
      bodyStyle={{
        padding: 14,
        paddingTop: 16,
        flex: 1,
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
      }}
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        border: selected
          ? `2px solid ${SELECTED_BORDER}`
          : "1px solid #f0f0f0",
      }}
      cover={
        <div
          style={{
            height: 140,
            margin: "12px 8px 0",
            borderRadius: 6,
            background: "#fff",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
            flexShrink: 0,
          }}
        >
          {product.thumb ? (
            <img
              src={product.thumb}
              alt={product.name}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                display: "block",
              }}
            />
          ) : (
            <ImageIcon size={26} strokeWidth={1.5} color="rgba(0,0,0,0.18)" />
          )}
          <Checkbox
            checked={selected}
            onClick={(e) => {
              e.stopPropagation();
              onToggle(product);
            }}
            style={{ position: "absolute", top: 8, left: 8 }}
          />
          <Tag
            color={product.published ? "success" : "warning"}
            style={{
              position: "absolute",
              bottom: 8,
              right: 12,
              marginInlineEnd: 0,
            }}
          >
            {product.published ? "Publicerad" : "Material saknas"}
          </Tag>
        </div>
      }
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flex: 1,
          minHeight: 0,
          gap: 8,
        }}
      >
        <div style={{ minHeight: 40, marginTop: 4 }}>
          <Text style={{ fontWeight: 500, display: "block" }}>{product.name}</Text>
          <Text type="secondary" style={{ fontSize: 12 }}>
            {product.sku}
          </Text>
        </div>
        <Space size={6} wrap>
          <Tag color="geekblue" style={{ marginInlineEnd: 0 }}>
            {product.imageCount}{" "}
            {product.imageCount === 1 ? "bild" : "bilder"}
          </Tag>
          <Tag
            color={product.docCount ? "default" : "warning"}
            style={{ marginInlineEnd: 0 }}
          >
            {product.docCount
              ? `${product.docCount} dokument`
              : "Datablad saknas"}
          </Tag>
        </Space>
        <div style={{ flex: 1, minHeight: 8 }} />
        <Button block onClick={() => onOpen(product)}>
          Visa & välj filer
        </Button>
      </div>
    </Card>
  );
};
